import { render, staticRenderFns } from "./digital-currency-20-animated-currency-label.vue?vue&type=template&id=6d54e850&scoped=true&"
import script from "./digital-currency-20-animated-currency-label.vue?vue&type=script&lang=ts&"
export * from "./digital-currency-20-animated-currency-label.vue?vue&type=script&lang=ts&"
import style0 from "./digital-currency-20-animated-currency-label.vue?vue&type=style&index=0&id=6d54e850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d54e850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VList,VListItem,VListItemContent,VListItemTitle,VMenu})
